import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CancelPolicyResponse, PurchaseResponse, CancelPolicyClass } from '../Models/TravelInsuranceProperties';
import { NgForm } from '@angular/forms';
import { InsuranceService } from '../Services/insurance-service.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-travel-insurance-cancellation',
  templateUrl: './travel-insurance-cancellation.component.html',
  styleUrls: ['./travel-insurance-cancellation.component.css']
})

export class TravelInsuranceCancellationComponent implements OnInit {
  @ViewChild('sweet', { static: false }) sweetTemplate!: TemplateRef<any>;
  @ViewChild('bad', { static: false }) badTemplate!: TemplateRef<any>;
  constructor(private insuranceService: InsuranceService, private router: Router, private modelSuccess: NgbModal) { }

  ngOnInit() {
  }
  DetailsCompleted: boolean = false;
  cancelPolicy: CancelPolicyClass = new CancelPolicyClass;
  cancelloader: boolean = false;
  reqData: PurchaseResponse = new PurchaseResponse();
  cancelPolicyResponse: CancelPolicyResponse = new CancelPolicyResponse();
  CancelBookedPlans() {
    this.cancelloader = true;
    this.reqData.ItineraryID = this.cancelPolicy.itinerary;
    this.reqData.PolicyNo = this.cancelPolicy.policyno;
    this.reqData.PNR = this.cancelPolicy.pnr;
    this.reqData.PolicyPurchasedDateTime = this.cancelPolicy.purchaseDate.toString();
    this.reqData.ErrorCode = "";
    this.insuranceService.CancelInsurancePolicy(this.reqData).subscribe(data => {
      this.cancelPolicyResponse = data;
      this.cancelloader = false;
      if (this.cancelPolicyResponse.PolicyResponse.ItineraryState == "" || this.cancelPolicyResponse.PolicyResponse.ErrorCode == "0") {
        this.modelSuccess.open(this.sweetTemplate, {
          backdrop: 'static',
          size: 'lg',
          centered: true
        })
      } else {
        this.modelSuccess.open(this.badTemplate, {
          backdrop: 'static',
          size: 'lg',
          centered: true
        })
      }
    });
  }
  ToDashboard() {
    this.router.navigateByUrl('zeusBookedPolicy');
  }
}
